module.exports = __webpack_public_path__ + "static/media/shopify-shipping-deadline.3dfd1332.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shopify-shipping-deadline.png
// module id = 388
// module chunks = 0